import React from "react";
import PropTypes from "prop-types";

const Flexbox = ({
	justifyContent,
	alignItems,
	children,
	inline,
	flexDirection
}) => (
	<div
		style={{
			display: !inline ? "flex" : "inline-flex",
			justifyContent,
			alignItems,
			flexDirection
		}}>
		{children}
	</div>
);

Flexbox.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node)
	]).isRequired,
	inline: PropTypes.bool,
	justifyContent: PropTypes.string,
	alignItems: PropTypes.string,
	flexDirection: PropTypes.string
};

Flexbox.defaultProps = {
	inline: false,
	justifyContent: "center",
	alignItems: "center",
	flexDirection: "row"
};

export default Flexbox;
